import { useState, useContext, createContext } from 'react'
import PropTypes from 'prop-types'

export const AlertContext = createContext()
export const useAlert = () => useContext(AlertContext)
export const AlertProvider = ({ children }) => {
  /*
    Success Alert
    - Fades away after timeout
    - Can be closed using 'x' icon
    - Does not close on clickaway
  */
  const [showSuccess, setShowSuccess] = useState(false)
  const [successTitle, setSuccessTitle] = useState('')
  const [successDuration, setSuccessDuration] = useState(4000)
  const handleSuccessClose = (event, reason) => {
    // closeButton-click: reason = undefined
    // Timeout: reason = 'timeout'
    // click outside alert: reason = 'clickaway'
    // console.log('Success:close:', event, reason)
    if (reason === 'clickaway') return
    setShowSuccess(false)
  }

  /*
    Error Alert
    - Does not automatically fade away
    - Can be closed using 'x' icon
    - Can be closed using clickaway (click anywhere outside alert)
  */
  const [showError, setShowError] = useState(false)
  const [errorTitle, setErrorTitle] = useState('')
  const [errorMessage, setErrorMessage] = useState()
  const handleErrorClose = () => setShowError(false)

  return (
    <AlertContext.Provider
      value={{
        showSuccess,
        successTitle,
        successDuration,
        setShowSuccess,
        setSuccessTitle,
        setSuccessDuration,
        handleSuccessClose,
        showError,
        errorTitle,
        errorMessage,
        setShowError,
        setErrorTitle,
        setErrorMessage,
        handleErrorClose,
      }}
    >
      {children}
    </AlertContext.Provider>
  )
}

AlertProvider.propTypes = {
  children: PropTypes.node,
}
